
import { Vue, Options } from "vue-class-component";
import { assetsModule, usersModule, languagesModule } from "@/store";
import { checkAccess } from "@/permission";
import { AccessTypes, AssetsInterface } from "@/types";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import { PropType } from "vue";
import { hasAccessToPinnedAssets } from "@/utils/assetAccessChecker";

@Options({
  name: "ToggleAssetPinButton",
  components: { SvgIcon },
  props: {
    asset: {
      type: Object as PropType<AssetsInterface>,
    },
  },
})
export default class ToggleAssetPinButton extends Vue {
  protected asset!: AssetsInterface;
  protected hasAccessToPinnedAssets = hasAccessToPinnedAssets();

  protected get pinnedAssets(): AssetsInterface[] {
    return assetsModule.getPinnedAssets;
  }

  protected get isPinnedAssetsLoading(): boolean {
    return assetsModule.getPinnedAssetsLoader;
  }

  protected get isPinned(): boolean {
    if (this.asset && this.hasAccessToPinnedAssets) {
      const pinnedAssetIndex = this.pinnedAssets.findIndex(
        (pinnedAsset: AssetsInterface) => pinnedAsset.id == this.asset!.id
      );
      return pinnedAssetIndex > -1;
    } else {
      return false;
    }
  }

  protected handlePin(asset: AssetsInterface | undefined, isPinned: boolean): void {
    const lang = languagesModule.getActiveLanguageCode;

    if (usersModule.IsAuthenticated && lang) {
      if (isPinned) {
        assetsModule.UnpinAsset({lang, assetId: asset?.id});
      } else {
        assetsModule.PinAsset({lang, assetId: asset?.id});
      }
    }
  }

  protected buttonTitle(hasAccessToAsset: boolean, isPinned: boolean): string {
    if (!hasAccessToAsset) {
      return this.$t("tooltips.pin_button.no_access");
    } else if (isPinned) {
      return this.$t("tooltips.pin_button.unpin");
    } else {
      return this.$t("tooltips.pin_button.pin");
    }
  }
}
